export default class StompMessage {
    static REQUEST_ACTIVATE = 'activate';
    static REQUEST_DEACTIVATE = 'deactivate';
    static REQUEST_SUBSCRIBE = 'subscribe';
    static REQUEST_PUBLISH = 'publish';
    static REQUEST_CREATE = 'request_create';
    static BROKER_BEFORE_CONNECT = 'before_connect';
    static BROKER_CONNECT = 'connect';
    static BROKER_WEBSOCKET_CLOSE = 'websocket_close';
    static BROKER_WEBSOCKET_ERROR = 'websocket_error';
    static BROKER_STOMP_ERROR = 'stomp_error';
    static BROKER_STOMP_SUBSCRIBED_CALLBACK = 'stomp_subscribed_callback'
    static SHARED_WORKER_ERROR = 'worker_error';
    static SHARED_WORKER_BROKER_CONNECTION_CHECK = 'broker_check'
    static SHARED_WORKER_CLIENT_CONNECTION_ACK = 'client_ack'
    static NONSPECIFIC_ID = "*";

    static create(senderId, destinationId,  name, data){
        //UV6-1581 console.log("message: " + name );
        return {
            senderId: senderId, // clientId or brokerURL if specific "" if non-specific
            destinationId: destinationId, // clientId or brokerURL if specific "" if non-specific
            name:name,
            data:data || {},
        }
    }

    static createSubscriberMessage(senderId, subscriptionId, data){
        //UV6-1581 console.log("subscriber message" );
        return {
            senderId: senderId, // brokerURL if specific "" if non-specific
            destinationId: StompMessage.NONSPECIFIC_ID, // message for all clients connected to the broker.
            subscriptionId: subscriptionId, // message for all clients subscribing to this    
            name: StompMessage.BROKER_STOMP_SUBSCRIBED_CALLBACK,
            data:data || {},
        }
    }

}